/** Copy for picking specific product variants. */
export const shopifyVariantsCopy = {
  showVariants: (count?: number) => (count ? `Show ${count} variants` : 'Show variants'),
  hideVariants: 'Hide variants',
  loading: 'Loading variants…',
  loadError: 'Couldn’t load variants.',
  retry: 'Try again',
  empty: 'This product has no variants to pick.',
  loadAllToChange:
    'This product is included whole. Load all its variants before unticking one, so none are dropped.',
  loadMore: 'Load more variants',
  selectedOf: (n: number) => `${n} variant${n === 1 ? '' : 's'} selected`,
  chipLabel: (productTitle: string, variantTitle: string) => `${productTitle} — ${variantTitle}`,
  summary: (products: number, variants: number) =>
    [
      products > 0 && `${products} product${products === 1 ? '' : 's'}`,
      variants > 0 && `${variants} variant${variants === 1 ? '' : 's'}`,
    ]
      .filter(Boolean)
      .join(', '),
} as const;
